<template>
  <div
    class="absolute left-0 top-20 aspect-[1.78/1] w-full rounded-3xl bg-cover bg-center bg-no-repeat md:relative md:top-0 md:aspect-[3.09/1] md:min-h-[250px]"
    :style="{
      backgroundImage: currentBackgroundImage
        ? `url(${currentBackgroundImage})`
        : undefined,
      color: textColor || undefined,
    }"
  >
    <div
      class="absolute left-[4%] top-[10%] w-[46%] md:left-[6%] md:top-[38%] md:w-[33%]"
    >
      <h1
        v-if="title"
        class="mb-2 text-xl font-bold md:text-2xl"
        v-html="title"
      ></h1>
      <p v-if="subtitle" class="text-md" v-html="subtitle"></p>
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  useBreakpoints,
} from '#imports'
import type { ZnHeaderProps } from './types'

const props = defineProps<ZnHeaderProps>()

const isMobileState = ref(false)

const checkMobile = () => {
  isMobileState.value = useBreakpoints().isMobile.value
}

onMounted(() => {
  checkMobile()

  window.addEventListener('resize', checkMobile)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkMobile)
})

const currentBackgroundImage = computed(() => {
  if (isMobileState.value && props.mobileBackgroundImage) {
    return props.mobileBackgroundImage
  }
  return props.backgroundImage
})
</script>
